import { render, staticRenderFns } from "./EditTeamDialog.vue?vue&type=template&id=53c865ed&scoped=true&"
import script from "./EditTeamDialog.vue?vue&type=script&lang=js&"
export * from "./EditTeamDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c865ed",
  null
  
)

export default component.exports